// components/ProtectedRoute.js
import { Navigate } from "react-router-dom";
import { useLocation, NavLink } from "react-router-dom";

const ProtectedRoute = ({ children, allowedScopes }) => {
    const location = useLocation();

  const userScope = localStorage.getItem("scope"); // or wherever you store it
  const { pathname } = location;

if(userScope && !pathname.includes('profile') && !pathname.includes('verifyEmail')){
    if (!allowedScopes.includes(userScope)) {
        return <Navigate to="/unauthorized" />; // or a login page
      }
}
  

  return children;
};

export default ProtectedRoute;